import React, {useState, useEffect} from 'react'
import { useTranslation } from "react-i18next";
import Box from '@mui/material/Box';   
import Checkbox from '@mui/material/Checkbox'; 
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import TextField from '@mui/material/TextField';
import useTheme from '@mui/material/styles/useTheme';   
import visuallyHidden from '@mui/utils/visuallyHidden';
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsUserAccounts = [
  {
    id: 'indexrowuseraccount',
    numeric: false,
    disablePadding: false,
    label: 'Text_Row',
    canOrder:true,
  },
  {
    id: 'enablestoreuseraccount',
    numeric: false,
    disablePadding: false,
    label: 'Text_EnableUserAccountStore',
    canOrder:false,
  },
  {
    id: 'useraccount_username',
    numeric: false,
    disablePadding: false,
    label: 'Text_UsernameUserAccount',
    canOrder:true,
  },
  {
    id: 'useraccount_firstName',
    numeric: false,
    disablePadding: false,
    label: 'Text_FirstNameAccount',
    canOrder:true,
  },
  {
    id: 'useraccount_lastName1',
    numeric: false,
    disablePadding: false,
    label: 'Text_LastName1UserAccount',
    canOrder:true,
  },
  {
    id: 'useraccount_lastName2',
    numeric: false,
    disablePadding: false,
    label: 'Text_LastName2UserAccount',
    canOrder:true,
  },
  {
    id: 'useraccount_email',
    numeric: false,
    disablePadding: false,
    label: 'Text_EmailUserAccount',
    canOrder:true,
  },
  {
    id: 'useraccount_aliasuser',
    numeric: false,
    disablePadding: false,
    label: 'Text_AliasuserUserAccount',
    canOrder:true,
  },
  {
    id: 'useraccount_role',
    numeric: false,
    disablePadding: false,
    label: 'Text_RoleUserAccount',
    canOrder:true,
  }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
  
function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
        return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {headCellsUserAccounts.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { numTotRegUserAccount, t, inputTextUserAccount, inputHandlerUserAccount} = props;
    return (
    <Toolbar>
     
      <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 16}} id="tableTitle" component="div">
        <p>{t('Text_Store_UserAccount')}</p> 
        <div className="form-group">
          <label className="text-primary">{t('Text_Search')}&nbsp;&nbsp;</label>
          <TextField
            id="inputTextUserAccount" 
            name="inputTextUserAccount"
            value={inputTextUserAccount}
            InputLabelProps={{ style: {fontSize: '18px', background: 'white'}}} 
            inputProps={{ style: {width: 700,fontSize: '18px'}, maxLength: 100 }}
            label={t('Text_UserAccoountStore_Search')}
            placeholder={t('Text_UserAccoountStore_Search')}
            variant="outlined"                                   
            onChange={inputHandlerUserAccount}
          />
       
         </div>
      </Typography>
      <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 14}} id="tableTitle" component="div">
        {t('Text_Num_Reg')} {(numTotRegUserAccount).toLocaleString('de-DE')} {t('Text_Of')}  {(numTotRegUserAccount).toLocaleString('de-DE')}
      </Typography>
    </Toolbar>
  );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataStores']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingUserAccounts =(props)=>{
  const { dataUserAccounts,  checkedRow, numTotRegUserAccount, setInputTextUserAccount, LIMITPAGESIZE } = props;
  const {t} = useTranslation(['listDataStores']);
  const [order, setOrderUserAccount] = useState('asc');
  const [orderBy, setOrderUserAccountBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [emptyRowsUserAccount, setEmptyRowsUserAccount] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataUserAccounts.length) : 0);
  const [countData,setCountData] = useState(dataUserAccounts!==null ? dataUserAccounts.length:0);
  const [activeOffsetUserAccount, setActiveOffsetUserAccount]= useState(false);
  const [currencyOffsetUserAccount, setCurrencyOffsetUserAccount] = useState(1);
  const [rangeOffsetUserAccount, setRangeOffsetUserAccount] = useState([{}]);

  useEffect(() => {
    if (dataUserAccounts.length !== countData || dataUserAccounts.length <= rowsPerPage) {
      setPage(0);
    }  
    setCountData(dataUserAccounts.length);
    setEmptyRowsUserAccount(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataUserAccounts.length) : 0);
  }, [dataUserAccounts, rowsPerPage, page, countData]);
  
  useEffect(() => {
    if (numTotRegUserAccount > LIMITPAGESIZE) {
      setActiveOffsetUserAccount(true);
      const ranges = [
        {
          value: 1,
          label: " 1 - " + Number(LIMITPAGESIZE).toLocaleString('de-DE'),
        },
      ];
      for (let i = Number(LIMITPAGESIZE); i < numTotRegUserAccount; i += Number(LIMITPAGESIZE)) {
        ranges.push({
          value: (i / Number(LIMITPAGESIZE)) + 1,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMITPAGESIZE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetUserAccount(ranges);
    } else {
      setCurrencyOffsetUserAccount(1);
      setActiveOffsetUserAccount(false);
      setRangeOffsetUserAccount([{}]);
    }
  }, [numTotRegUserAccount, LIMITPAGESIZE]);

  const handleChangeOffset = (event) => {
    setCurrencyOffsetUserAccount(event.target.value);
  };

  const handleRequestSortUserAccount = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrderUserAccount(isAsc ? 'desc' : 'asc');
    setOrderUserAccountBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  
  let inputHandlerUserAccount = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextUserAccount(lowerCase);
  };

  const listItemsUserAccount= (
  stableSort(dataUserAccounts, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keydataUserAccounts) => {
    return (
      <TableRow hover tabIndex={-1} key={keydataUserAccounts}>
        <TableCell align="left">
        <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.indexrowuseraccount}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Checkbox checked={row.enablestoreuseraccount} 
            sx={{
              '& .MuiSvgIcon-root': { color:checkedRow?"#4e73df":"#858796",fontSize: 28 }, // Ajusta el tamaño del ícono
            }}
            disabled 
          />
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.useraccount_username}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.useraccount_firstName}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.useraccount_lastName1}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.useraccount_lastName2}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.useraccount_email}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.useraccount_aliasuser}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:checkedRow?"#4e73df":"#858796", textDecorationLine:checkedRow?'none':'line-through', fontSize: 16}} >
            {row.useraccount_role}
          </Typography>
        </TableCell>

      </TableRow>
    );
  }));
  
  return(
    <>
      <Box sx={{ width: '99%'}}> 
        <EnhancedTableToolbar checkedRow={checkedRow} numTotRegUserAccount={numTotRegUserAccount} t={t}  inputHandlerUserAccount={inputHandlerUserAccount} />
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '1500px',width: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSortUserAccount} t={t} />
              <TableBody>    
                {listItemsUserAccount}
                {emptyRowsUserAccount > 0 && (
                <TableRow style={{ height: 22  * emptyRowsUserAccount}}>
                  <TableCell colSpan={10} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetUserAccount && (
                    <TableCell colSpan={10}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetUserAccount"
                            name="currencyOffsetUserAccount"
                            value={currencyOffsetUserAccount}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:12}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetUserAccount
                            }}>
                            {rangeOffsetUserAccount.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10]}
                    colSpan={10}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingUserAccounts.propTypes = {
  dataUserAccounts: PropTypes.array.isRequired,
  checkedRow: PropTypes.bool.isRequired,
  numTotRegUserAccount: PropTypes.number.isRequired,
  setInputTextUserAccount: PropTypes.func.isRequired 
};

export default TableSortingUserAccounts;